import type { LoginRequiresVerificationResponse, User } from '@lambda/shared/types';

/** Minimal user for onboarding routes when full profile is not returned (anti-enumeration). */
export function onboardingUserStub(email: string): User {
  return {
    userId: '',
    email,
    name: '',
    role: 'parent',
    status: 'pending-verification',
    phoneNumber: '',
    phoneVerified: false,
    emailVerified: false,
    twoFactorEnabled: false,
    agreedToTerms: false,
    requiredDocumentsReviewed: [],
    createdAt: 0,
    updatedAt: 0,
  };
}

/** Build onboarding user from login when account still needs email/phone verification. */
export function onboardingUserFromLogin(data: LoginRequiresVerificationResponse): User {
  return {
    userId: data.userId,
    email: data.email,
    name: data.name,
    role: data.role,
    status: 'pending-verification',
    phoneNumber: data.phoneNumber,
    phoneVerified: data.phoneVerified,
    emailVerified: data.emailVerified,
    twoFactorEnabled: false,
    agreedToTerms: false,
    requiredDocumentsReviewed: [],
    createdAt: 0,
    updatedAt: 0,
  };
}

/** True when user is mid sign-up (email/phone verification) without a full session yet. */
export function isPendingOnboardingUser(user: User): boolean {
  return isCompletingOnboardingSession(user);
}

/**
 * True while the user is still in the registration flow (before they can use the app).
 * Includes staff/tutor/board invited users who are pending approval but still setting up 2FA.
 */
export function isCompletingOnboardingSession(user: User): boolean {
  if (user.status === 'pending-verification') return true;
  if (user.status === 'pending-approval' && !user.twoFactorEnabled) return true;
  return false;
}
